import "./book.css";

import React from "react";

import { BOOKING } from "../../data/content";
import PageMeta from "../general/PageMeta";

//NightsBridge online booking, embedded full width as on Wix
const BookARoom = () => {
  return (
    <section className={"book"}>
      <PageMeta
        title={BOOKING.TITLE}
        description={BOOKING.DESCRIPTION}
      />
      <h1 className={"visually-hidden"}>{BOOKING.TITLE}</h1>
      <iframe
        className={"book-frame"}
        title={"Online booking (NightsBridge)"}
        src={BOOKING.EMBED_URL}
      />
    </section>
  );
};

export default BookARoom;
